import { useTranslation } from '~/_shared/utils/hooks';
import { useIsGeocodingRunningOrRequired } from '~/store/geocoding/geocoding.selectors';
import { useIsRowRelationsBeingProcessedOrRequiredSelector } from '~/store/rowRelations/rowRelations.selectors';

export const useIsBoundaryToolReady = () => {
  const [t] = useTranslation();
  const isGeocodingRunningOrRequired = useIsGeocodingRunningOrRequired();
  const isRowRelationsBeingProcessedOrRequiredSelector = useIsRowRelationsBeingProcessedOrRequiredSelector();

  const isGeocodingOrRowRelationSyncRequiredOrRunning = isGeocodingRunningOrRequired || isRowRelationsBeingProcessedOrRequiredSelector;
  const disabledReason = isGeocodingOrRowRelationSyncRequiredOrRunning ? t('Cannot use boundary before geocoding is completed and map is fully initialized.') : null;

  return {
    boundaryToolDisabledReason: disabledReason,
    isBoundaryToolPreparing: isGeocodingOrRowRelationSyncRequiredOrRunning,
  } as const;
};
